module.exports = __webpack_public_path__ + "static/img/guiluyaoye2.0505cb9d.png";